module.exports = __webpack_public_path__ + "static/media/om.52ea085c.svg";